import React, { useEffect } from 'react';
import { Tooltip } from 'bootstrap';
import { Icon } from '@iconify/react';
import { slideToggle } from './../../composables/slideToggle.js';

function Card(props) {
	return (
		<div className={'card '+ (props.className ? props.className : '')} style={props.style}>
			{ props.children }
		</div>
	);
};

function CardHeader(props) {
	return (
		<div className={'card-header '+ ((props.className) ? props.className : '') } style={props.style}>
			{ props.children }
		</div>
	);
}

function CardHeaderBtn(props) {
	return (
		<div className={'card-header-btn '+ ((props.className) ? props.className : '') } style={props.style}>
			<CardCollapseToggler />
			<CardExpandToggler />
			<CardRemoveToggler />
		</div>
	);
}

function CardBody(props) {
	return (
		<div className={"card-body "+ ((props.className) ? props.className : '')} style={props.style}>
			{ props.children }
		</div>
	);
};

function CardImgOverlay(props) {
	return (
		<div className={"card-img-overlay "+ ((props.className) ? props.className : '')} style={props.style}>
			{ props.children }
		</div>
	);
};

function CardFooter(props) {
	return (
		<div className={"card-footer "+ ((props.className) ? props.className : '')} style={props.style}>
			{ props.children }
		</div>
	);
};

function CardGroup(props) {
	return (
		<div className={"card-group "+ ((props.className) ? props.className : '')} style={props.style}>
			{ props.children }
		</div>
	);
};


function CardExpandToggler(props) {
	const tooltipRef = React.createRef();
	
	useEffect(() => {
		new Tooltip(tooltipRef.current, {
			title: 'Expand / Compress',
			placement: 'bottom',
			trigger: 'hover',
			container: 'body'
		});
	});
	
	function toggleCardExpand(e) {
		e.preventDefault();
		
		var target = (e.target).closest('.card');
		var targetClass = 'card-expand';

		if (document.body.classList.contains(targetClass) && target.classList.contains(targetClass)) {
			target.removeAttribute('style');
			target.classList.remove(targetClass);
			document.body.classList.remove(targetClass);
		} else {
			document.body.classList.add(targetClass);
			target.classList.add(targetClass);
		}

		window.dispatchEvent(new Event('resize'));
	}
	
	return (
		<a href="#/" onClick={toggleCardExpand} ref={tooltipRef} className="btn"><Icon icon="material-symbols-light:fullscreen" /></a>
	);
}


function CardCollapseToggler(props) {
	const tooltipRef = React.createRef();
	
	useEffect(() => {
		new Tooltip(tooltipRef.current, {
			title: 'Collapse',
			placement: 'bottom',
			trigger: 'hover',
			container: 'body'
		});
	});
	
	function toggleCardCollapse(e) {
		e.preventDefault();
		
		var card = (e.target).closest('.card');
		if (card) {
			var target = card.querySelector('.card-body');
			slideToggle(target);
		}
	}
	
	return (
		<a href="#/" onClick={toggleCardCollapse} ref={tooltipRef} className="btn"><Icon icon="material-symbols-light:stat-minus-1" /></a>
	);
}


function CardRemoveToggler(props) {
	const tooltipRef = React.createRef();
	
	useEffect(() => {
		new Tooltip(tooltipRef.current, {
			title: 'Remove',
			placement: 'bottom',
			trigger: 'hover',
			container: 'body'
		});
	});
	
	function toggleCardRemove(e) {
		e.preventDefault();
		
		var target = (e.target).closest('.card');
		if (target) {
			var tooltip = Tooltip.getInstance(tooltipRef.current);
			if (tooltip) {
				tooltip.dispose();
			}
			target.remove();
		}
	}
	
	return (
		<a href="#/" onClick={toggleCardRemove} ref={tooltipRef} className="btn"><Icon icon="material-symbols-light:close-rounded" /></a>
	);
}

export { Card, CardHeader, CardHeaderBtn, CardBody, CardImgOverlay, CardFooter, CardGroup, CardExpandToggler, CardCollapseToggler, CardRemoveToggler };
